<template>
  <div class="entete" v-if="nouveauDevisCommande">
    <a ref="lienDownload"></a>
    <b-modal v-model="isComponentPopUpErreurPerso"
      has-modal-card
      class="modal">
      <app-popup-erreur-perso
          :messHeader="this.$t('ligneRegroupementPersonnalisee.popup.unableToCreate')"
          :messagesPopup="messagesPopup"
      />
    </b-modal>
    <div class="level">
      <div class="level-left">
        <div class="columns is-gapless">
          <div class="column">
            <h1 class="title is-size-3" v-if="isNewDevisCommande">
              {{ !isCreditNote ? $t('editionFacture.title')
              : $t('editionFacture.titleFactureAvoir') }}</h1>
            <h1 class="title is-size-3" v-else>
              {{ getTitleEdit }}
            </h1>
            <app-breadcrumb :breadcrumb="breadcrumb"/>
          </div>
        </div>
      </div>
      <div class="level-right" v-if="canSeeFacture">
        <div class="buttons">
          <a class="button is-cancel btn-modal-annuler " @click="annuler()">
            {{ $t('editionFacture.actions.revert')}}
          </a>
          <a class="button is-addOrEdit " @click="checkBeforeSave()">
            {{ $t('editionFacture.actions.save')}}
          </a>
          <button class="button" v-if="isPublid" >
            <b-dropdown position="is-bottom-left" class="positionInitial">
              <b-icon icon="dots-vertical" slot="trigger" role="button" type="is-default">
              </b-icon>
              <b-dropdown-item @click="getExcelProduitReseauNum()">
                {{ $t('exportExcelReseauNum.exportExcel') }}
              </b-dropdown-item>
              <b-dropdown-item @click="popUpImportExcel = true">
                {{ $t('exportExcelReseauNum.importExcel') }}
              </b-dropdown-item>
            </b-dropdown>
          </button>
          <piece-jointe-button
            class="mgr-2"
            :perm="constantes.FACTURES.maj">
          </piece-jointe-button>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                        :error="error"
                        :title="'editionClient.problemOccurred'"
                        :withEmplyFields="true"
                        :messagesChampsVide="messagesChampsVide"
                        :champsVide="champsVide"
                        @close="error = $event"/>
    <div class="tab" v-if="canSeeFacture">
      <ul>
        <li @click="changeOnglet('AppEditionFacture')"
            :class="{'is-active': activeTab === 'AppEditionFacture'}">
          {{ $t('editionFacture.onglet.facture')}}
        </li>
        <li @click="activeTab = 'AppAchatFacture'"
              :class="{ 'is-active': activeTab === 'AppAchatFacture' }"
              v-if="moduleAchatAASpe">
            {{ $t('editionFacture.onglet.achats') }}
        </li>
        <b-tooltip v-if="nouveauDevisCommande.montantTtc === 0"
                   :label="$t('editionFacture.echeancierPaiement.montantTtcZero')">
          <li class="pointer-events-none text-access-no-permission">
            {{ $t('editionFacture.onglet.echeancier')}}
          </li>
        </b-tooltip>
        <li @click="changeOnglet('AppEcheancierPaiement')" v-else
            :class="{'is-active': activeTab === 'AppEcheancierPaiement'}">
          {{ $t('editionFacture.onglet.echeancier')}}
        </li>
        <li :class="[{'is-active': activeTab === 'commissions'}]"
            @click="activeTab = 'commissions'" v-if="modulePresseActive">
            {{ $t('editionCommande.tabs.commissions') }}
          </li>
        <li :class="{'is-active': activeTab === 'AppPrevisualisation'}"
            @click="changeOnglet('AppPrevisualisation')">
          {{ $t('editionFacture.onglet.previsualisation') }}
        </li>
        <li :class="{'is-active': activeTab === 'AppFactor'}"
            v-if="moduleFactorActive"
            @click="changeOnglet('AppFactor')">
          {{ $t('editionFacture.onglet.factor') }}
        </li>
      </ul>
    </div>
    <div v-else >
      <app-information-msg-component :title="'general.info'"
                                     :libelleList="[{ isLink: false,
                                       libelle: $t('general.noAccess') }]"
                                     :canClose="false"
      >
      </app-information-msg-component>
    </div>
    <b-modal v-model="popUpImportExcel"
             has-modal-card
             class="modal">
      <pop-up-import-excel
        :haveAlreadyVente="nouveauDevisCommande.lignesCommande.length > 0"
        @addXlsxFile="readAndCreateLignes">
      </pop-up-import-excel>
    </b-modal>
    <b-modal v-model="popUpChoiceSavePrevisualisation"
             has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('previsualisation.titlePopUp')"
        :cancel="$t('previsualisation.actions.cancel')"
        :validate="$t('previsualisation.actions.saveWithNewPrevisualisation')"
        :otherButton="$t('previsualisation.actions.saveWithoutNewPrevisualisation')"
        @no="popUpChoiceSavePrevisualisation = false"
        @yes="saveWithChange"
        @otherButtonSelect="saveWithoutChange"
      ></pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpFactor" has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('editionFacture.popUpFactor.title')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="openPopUpFactor = false"
        @yes="saveFacture">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpProduit" has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('editionFacture.popUpProduct.title')"
        :messagesHtml="lignesSansProduitMessage"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpProduit = false;"
        @yes="saveFacture">
        {{ nouveauDevisCommande.lignesCommande.libelle }}
      </pop-up-prevention>
    </b-modal>
    <div v-if="canSeeFacture">
      <component :is="activeTab" :factureDetail="nouveauDevisCommande"
                 :isNewDevisCommande="isNewDevisCommande"
                 v-if="nouveauDevisCommande"
                 :breadcrumb="breadcrumb"
                 :isCreditNote="isCreditNote"
                 :isAvoirLibre="isAvoirLibre"
                 @errorEvent="findError"
                 :isEditPrevisu="isEditPrevisu"
                 :isEdit="true"
                 :plan-media="nouveauDevisCommande"
                 :dcf="nouveauDevisCommande"
                 :devisCommande="nouveauDevisCommande"
                 @changeIsEditPrev="isEditPrevisu = $event"
                 @masqueLigneChange="masqueLigneChange"
                 @masqueRemiseChange="nouveauDevisCommande.masqueRemise = $event"
                 @erreurRegroupementPersonnalise= "erreurRegroupementPersonnalise"/>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import AppEditionFacture from '@/components/factures/m_editionFacture';
import AppEcheancierPaiement from '@/components/factures/echeancierPaiement';
import defineTitreIntervenant from '@/services/devisCommandes/defineTitreIntervenant';
import * as devisConf from '@/configuration/devisConf';
import initializeCommandeDevis from '@/services/devisCommandes/initializeCommandeDevis';
import genererDevisCommande from '@/services/devisCommandes/genererDevisCommande';
import genererIntervenant from '@/services/devisCommandes/genererIntervenant';
import { create, update } from '@/api/facture/index';
import { factureGetterAsync as factureGetter } from '@/services/devisCommandes/devisCommandeGetter';
import validationGeneral from '@/services/validation/validation';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';
import preparationEnvoiBack from '@/services/devisCommandes/preparationEnvoiBack/preparationEnvoiBack';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import gestionDateBase from '@/services/general/gestionDateBase';
import commissions from '@/components/planMedia/edition/commissions';
import * as types from '@/store/modules/commande-mutation-type';
import { GUID_VIDE } from '@/configuration/general';
import formatDate from '@/services/general/formatIsoDate';
import { COMMERCIAL, ASSISTANT_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import {
  ajouterProduitDepuisPanierNumerique,
  ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo,
} from '@/services/devisCommandes/ajoutProduit/ajouterProduitDepuisPanier';
import * as typesProduitNumerique from '@/store/modules/produitEcranNumerique-mutation-type';
import * as typesfacture from '@/store/modules/facture-mutation-type';
import * as produitConf from '@/configuration/catalogue/produitConf';
import popupErreur from '@/components/general/popUpErreur';
import * as typesProduitFace from '@/store/modules/produitFace-mutation-type';
import reordonnancementRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/reordonnancementRegroupementPersonnalise';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import calculCommandeDevis from '@/services/devisCommandes/calcul/calculCommandeDevis';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import * as typesProduitReseauTempo from '@/store/modules/planningReseauTempo-mutation-type';
import * as typesProduitReseauLc from '@/store/modules/produitReseauLc-mutation-type';
import * as typesProduitReseauMairie from '@/store/modules/bodac/catalogue/produitReseauMairie-mutation-type';
import popUpImportExcel from '@/components/devisCommandes/editionDevisCommande/p_importExcel';
import readFileXlsx from '@/services/general/readFileXlsx';
import fromLignesXlsxToTab from '@/services/excel/produitReseauNumerique/fromLignesXlsxToTab';
import { ajoutLignesCommandeProduitReseauNumfromXlsx } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauNumerique';
import categorieVenteInitialize from '@/services/devisCommandes/categorieVenteInitialize';
import { updateAffectionOfAllProduct } from '@/services/affectation/affectation';
import echeancierGeneration from '@/services/facture/generationEcheancier';
import calculDateEcheancier from '@/services/facture/dateDebutEcheancier';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import AppPrevisualisation from '@/components/devisCommandeFacture/previsualisation/previsualisation';
import updateMasqueLigneWithOrdre from '@/services/devisCommandes/ligneCommande/updateMasqueLigneWithOrdre';
import regleFacturationInitialize from '@/services/devisCommandes/regleFacturationInitialize';
import popUpPrevention from '@/components/general/popUpPrevention';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import exportExcel from '@/api/exportExcel';
import { TYPE_DONNE_EXPORT_RESEAU_NUM_PUBLID } from '@/configuration/dcf/dcfConf';
import updateModeCalculHonoraireLigneCommandeHonoraire from '@/services/ligneCommande/updateModeCalculHonoraire';
import majIntervenant from '@/services/devisCommandes/majIntervenant';
import AppAchatFacture from '@/components/devisCommandes/achat/editionAchatDevisCommande';
import * as typesProduitSalon from '@/store/modules/bodac/catalogue/produitSalon-mutation-type';
import * as typesProduitSponsoring from '@/store/modules/bodac/catalogue/produitSponsoring-mutation-type';
import * as typesProduitAutre from '@/store/modules/bodac/catalogue/produitAutre-mutation-type';
import * as typesProduitPresse from '@/store/modules/bodac/catalogue/produitPresse-mutation-type';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { FACTURES } from '@/configuration/permissionsBodacConf';
import AppFactor from '@/components/factures/m_factor';
import { getSocietePublid } from '@/services/excel/produitReseauNumerique/getProduitsLocForExportImportNum';
import agenceInitialize from '@/services/devisCommandes/agenceInitialize';
import checkDcfBeforeSave from '@/services/bodac/lignesCommande/critereRecherche/checkBeforeSave';
import validationChampsObligatoireFacture from '@/services/devisCommandes/validation/validationChampsObligatoireFacture';

const Commandes = createNamespacedHelpers('commande');
const Attachments = createNamespacedHelpers('attachments');
const societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const produitNumerique = createNamespacedHelpers('produitEcranNumerique');
const produitFace = createNamespacedHelpers('produitFace');
const ProduitReseauTempo = createNamespacedHelpers('planningReseauTempo');
const ProduitReseauLc = createNamespacedHelpers('produitReseauLc');
const ProduitReseauMairie = createNamespacedHelpers('produitReseauMairie');
const ProduitSalon = createNamespacedHelpers('produitSalon');
const ProduitSponsoring = createNamespacedHelpers('produitSponsoring');
const ProduitAutre = createNamespacedHelpers('produitAutre');
const ProduitPresse = createNamespacedHelpers('produitPresse');
const factures = createNamespacedHelpers('facture');
const Parametres = createNamespacedHelpers('parametres');
const Clients = createNamespacedHelpers('clients');

export default {
  components: {
    AppBreadcrumb,
    AppEditionFacture,
    AppEcheancierPaiement,
    appPopupErreurPerso: popupErreur,
    errorMsgComponent,
    popUpImportExcel,
    AppPrevisualisation,
    popUpPrevention,
    AppInformationMsgComponent,
    AppAchatFacture,
    AppFactor,
    commissions,
    pieceJointeButton,
  },
  data() {
    return {
      activeTab: 'AppEditionFacture',
      isEditPrevisu: false,
      masqueRemiseBase: false,
      popUpProduit: null,
      lignesMasqueLigneBase: [],
      popUpChoiceSavePrevisualisation: false,
      error: false,
      nouveauDevisCommande: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      etatLibelle: '',
      messagesPopup: [],
      lignesSansProduitMessage: [],
      isComponentPopUpErreurPerso: false,
      popUpImportExcel: false,
      factureSave: null,
      constantes: {
        ETAT_BROUILLON: devisConf.ETAT_BROUILLON,
        FACTURES,
      },
      olTiersFactorId: null,
      openPopUpFactor: false,
    };
  },
  computed: {
    ...Clients.mapGetters({
      clientCourant: 'clientCourant',
      placeIntervenant: 'placeIntervenant',
    }),
    ...ProduitReseauMairie.mapGetters({
      panierReseauMairie: 'panier',
      useEcranAjoutReseauMairie: 'useEcranAjout',
    }),
    ...ProduitSalon.mapGetters({
      panierSalon: 'panier',
      useEcranAjoutSalon: 'useEcranAjout',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    ...ProduitSponsoring.mapGetters({
      panierSponsoring: 'panier',
      useEcranAjoutSponsoring: 'useEcranAjout',
    }),
    ...ProduitAutre.mapGetters({
      panierAutre: 'panier',
      useEcranAjoutAutre: 'useEcranAjout',
    }),
    ...ProduitPresse.mapGetters({
      panierPresse: 'panier',
      useEcranAjoutPresse: 'useEcranAjout',
    }),
    ...factures.mapGetters({
      avoirACreer: 'avoirACreer',
      factureCourante: 'facture',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Commandes.mapGetters({
      commandeCourante: 'commande',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    ...ProduitReseauTempo.mapGetters({
      panierReseauTempo: 'panier',
      regroupPersoReseauTempo: 'regroupementPersonnalise',
      useEcranAjoutReseauTempo: 'useEcranAjout',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
      site: 'site',
    }),
    ...produitFace.mapGetters({
      regroupPersoFace: 'regroupementPersonnalise',
      panierFace: 'panier',
      useEcranAjoutFace: 'useEcranAjout',
    }),
    ...produitNumerique.mapGetters({
      panierNumerique: 'panier',
      regroupPersoNumerique: 'regroupementPersonnalise',
    }),
    ...ProduitReseauLc.mapGetters({
      panierReseauLc: 'panier',
      regroupPersoReseauLc: 'regroupementPersonnalise',
      useEcranAjoutReseauLc: 'useEcranAjout',
    }),
    moduleAchatAASpe() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.achatAASpe.key);
    },
    isPublid() {
      return !!getSocietePublid();
    },
    getTitleEdit() {
      return this.$i18n.t('editionFacture.' + (!this.isCreditNote ? 'updateTitle' : 'updateTitleAvoir'), { code: cloneDeep(this.nouveauDevisCommande.code) });
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeFactures.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeFactures.title'), route: { name: 'l.bodac.factures' }, isActive: false },
        {
          title: !this.isCreditNote ? this.$i18n.t('editionFacture.title')
            : this.$i18n.t('editionFacture.titleFactureAvoir'),
          route: { name: 'm.bodac.factures' },
          isActive: true,
        },
      ];
      if (!this.isNewDevisCommande) {
        output[2].title = this.getTitleEdit;
        output[2].route = {
          name: 'm.bodac.factures-edition',
          params: { id: this.id },
        };
      }
      return output;
    },
    delaisReglementFacture() {
      return this.parametre(PARAMETRES_KEYS.delaiReglement).find(item => {
        return item.id === this.nouveauDevisCommande.delaiReglementId;
      });
    },
    canSeeFacture() {
      if (!this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key)) return true;
      return (this.isNewDevisCommande || this.utilisateur.profil !== COMMERCIAL
        || (this.utilisateur.profil === COMMERCIAL
          && this.utilisateur.id === this.nouveauDevisCommande.commercialId));
    },
    isNewDevisCommande() {
      return this.nouveauDevisCommande
        && (!this.nouveauDevisCommande.id
          || this.nouveauDevisCommande.id === GUID_VIDE);
    },
    isCommercial() {
      return ((this.isNewDevisCommande && this.utilisateur.profil === COMMERCIAL)
        || (!this.isNewDevisCommande && this.utilisateur.profil === COMMERCIAL
          && this.utilisateur.id === this.nouveauDevisCommande.commercialId));
    },
    isCreditNote() {
      return this.nouveauDevisCommande.sousType === devisConf.SOUS_TYPE_AVOIR
        || this.nouveauDevisCommande.sousType === devisConf.SOUS_TYPE_AVOIR_SUR_ACOMPTE;
    },
    isAvoirLibre() {
      return this.isCreditNote && !this.nouveauDevisCommande.referenceId;
    },
    moduleFactorActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleFactor.key);
    },
  },
  methods: {
    ...Commandes.mapMutations({
      removeCommande: types.REMOVE_COMMANDE,
    }),
    ...factures.mapMutations({
      setAvoirACreer: typesfacture.SET_AVOIR_A_CREER,
      removeFacture: typesfacture.REMOVE_FACTURE,
    }),
    ...produitNumerique.mapMutations({
      clearBriefNumerique: typesProduitNumerique.CLEAR_BRIEF,
      clearPanierNumerique: typesProduitNumerique.CLEAR_PANIER,
    }),
    ...produitFace.mapMutations({
      clearPanierFace: typesProduitFace.CLEAR_PANIER,
      clearBriefFace: typesProduitFace.CLEAR_BRIEF,
      setTypeDCFFace: typesProduitFace.SET_TYPE_DCF,
      setUseEcranAjoutFace: typesProduitFace.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitReseauMairie.mapMutations({
      clearBriefReseauMairie: typesProduitReseauMairie.CLEAR_BRIEF,
      clearPanierReseauMairie: typesProduitReseauMairie.CLEAR_PANIER,
      setTypeDCFReseauMairie: typesProduitReseauMairie.SET_TYPE_DCF,
      setUseEcranAjoutReseauMairie: typesProduitReseauMairie.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitReseauTempo.mapMutations({
      clearBriefReseauTempo: typesProduitReseauTempo.CLEAR_BRIEF,
      clearPanierReseauTempo: typesProduitReseauTempo.CLEAR_PANIER,
      setTypeDCFReseauTempo: typesProduitReseauTempo.SET_TYPE_DCF,
      setUseEcranAjoutReseauTempo: typesProduitReseauTempo.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitReseauLc.mapMutations({
      clearBriefReseauLc: typesProduitReseauLc.CLEAR_BRIEF,
      clearPanierReseauLc: typesProduitReseauLc.CLEAR_PANIER,
      setTypeDCFReseauLc: typesProduitReseauLc.SET_TYPE_DCF,
      setUseEcranAjoutReseauLc: typesProduitReseauLc.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitSalon.mapMutations({
      clearBriefSalon: typesProduitSalon.CLEAR_BRIEF,
      clearPanierSalon: typesProduitSalon.CLEAR_PANIER,
      setTypeDCFSalon: typesProduitSalon.SET_TYPE_DCF,
      setUseEcranAjoutSalon: typesProduitSalon.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitSponsoring.mapMutations({
      clearBriefSponsoring: typesProduitSponsoring.CLEAR_BRIEF,
      clearPanierSponsoring: typesProduitSponsoring.CLEAR_PANIER,
      setTypeDCFSponsoring: typesProduitSponsoring.SET_TYPE_DCF,
      setUseEcranAjoutSponsoring: typesProduitSponsoring.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitAutre.mapMutations({
      clearBriefAutre: typesProduitAutre.CLEAR_BRIEF,
      clearPanierAutre: typesProduitAutre.CLEAR_PANIER,
      setTypeDCFAutre: typesProduitAutre.SET_TYPE_DCF,
      setUseEcranAjoutAutre: typesProduitAutre.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitPresse.mapMutations({
      clearBriefPresse: typesProduitPresse.CLEAR_BRIEF,
      clearPanierPresse: typesProduitPresse.CLEAR_PANIER,
      setTypeDCFPresse: typesProduitPresse.SET_TYPE_DCF,
      setUseEcranAjoutPresse: typesProduitPresse.SET_USE_ECRAN_AJOUT,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Clients.mapActions({
      setClientCourant: 'setClientCourant',
      setPlaceIntervant: 'setPlaceIntervant',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      updateAttachments: 'update',
      insertAttachments: 'insert',
    }),
    getRemiseTvaDefaut(facture) {
      const agenceFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === facture.agenceId;
      });
      const regimesTva = this.parametre(PARAMETRES_KEYS.regimeTva);
      if (!agenceFind.regimeTvaId) return null;
      const regimeFind = regimesTva.find((regime) => {
        return regime.id === agenceFind.regimeTvaId;
      });
      return regimeFind ? regimeFind.tauxTva : null;
    },
    masqueLigneChange(ligne) {
      updateMasqueLigneWithOrdre(
        this.nouveauDevisCommande.lignesCommande, ligne.ordre, !ligne.masqueLigne,
      );
    },
    changeMasqueLigneToInitalMasqueLigne(lignesCommande) {
      lignesCommande.forEach((ligne) => {
        if (ligne.lignesCommande) {
          ligne.lignesCommande.forEach((ligneEnfant) => {
            const ligneInitial = this.lignesMasqueLigneBase.find((ligne) => {
              return ligneEnfant.id && ligne.id === ligneEnfant.id;
            });
            if (ligneInitial) ligneEnfant.masqueLigne = ligneInitial.masqueLigne;
            else ligneEnfant.masqueLigne = false;
          });
        }
      });
    },
    getLignesMasqueLigne(lignesCommande) {
      lignesCommande.forEach((ligne) => {
        if (ligne.lignesCommande) {
          const lignesFind = ligne.lignesCommande.filter((ligneEnfant) => {
            return ligneEnfant.masqueLigne && ligneEnfant.id;
          });
          if (lignesFind) {
            this.lignesMasqueLigneBase = this.lignesMasqueLigneBase.concat(cloneDeep(lignesFind));
          }
        }
      });
    },
    saveWithChange() {
      this.popUpChoiceSavePrevisualisation = false;
      this.isEditPrevisu = false;
      this.enregistrerDevisCommande();
    },
    saveWithoutChange() {
      this.popUpChoiceSavePrevisualisation = false;
      this.isEditPrevisu = false;
      this.nouveauDevisCommande.masqueRemise = this.masqueRemiseBase;
      this.changeMasqueLigneToInitalMasqueLigne(this.nouveauDevisCommande.lignesCommande);
      this.enregistrerDevisCommande();
    },
    async getExcelProduitReseauNum() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: TYPE_DONNE_EXPORT_RESEAU_NUM_PUBLID,
          nomFichier: '',
          typeExport: '',
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        messageSucces(this.$i18n.t('exportExcelReseauNum.messages.sucessCreationExcel'));
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('exportExcelReseauNum.messages.excelExportError'));
        loadingComponent.close();
        throw (e);
      }
    },
    findNewTypeProduit() {
      categorieVenteInitialize(this.nouveauDevisCommande);
    },
    async readAndCreateLignes(file) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const lignesXlsx = await readFileXlsx(file);
        const tabDonnnes = fromLignesXlsxToTab(lignesXlsx);
        if (tabDonnnes.length === 0) throw new Error();
        await ajoutLignesCommandeProduitReseauNumfromXlsx(
          this.nouveauDevisCommande, tabDonnnes,
          this.$i18n, this.getRemiseTvaDefaut(this.nouveauDevisCommande),
        );
        this.changeOrder();
        this.calcul();
        this.findNewTypeProduit();
        messageSucces(this.$i18n.t('importExcel.messages.sucessCreationLignes'));
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('importExcel.messages.errorCreationLignes'));
        loadingComponent.close();
        throw (e);
      }
    },
    changeOrder() {
      // On réordonne les éléments liées à un réseau personnalisé
      // pour les mettre en dessous de la ligne de réseau personnalisé
      reordonnancementRegroupementPersonnalise(this.nouveauDevisCommande.lignesCommande);
      this.nouveauDevisCommande.lignesCommande.forEach((ligneCommande) => {
        ajoutOrdre(ligneCommande, this.nouveauDevisCommande.lignesCommande.indexOf(ligneCommande));
      });
      this.calcul();
    },
    calcul() {
      calculCommandeDevis(this.nouveauDevisCommande);
    },
    async generationEcheancierPaiementSiUneLigneEchancierEtMontantDiff(facture) {
      if (facture.echeancierPaiement.length !== 1) {
        return;
      }
      if (facture.montantTtc === this.factureSave.montantTtc
        && facture.modeReglementId === this.factureSave.modeReglementId
        && facture.delaiReglementId === this.factureSave.delaiReglementId
        && facture.dateDevisCommande === this.factureSave.dateDevisCommande
        && facture.echeancierPaiement.length === this.factureSave.echeancierPaiement.length
        && facture.intervenants.find(i => i.payeur).tiersId
        === this.factureSave.intervenants.find(i => i.payeur).tiersId) {
        return;
      }

      if (!facture.delaiReglement) {
        return;
      }

      let dateEcheance;
      if (facture.echeancierPaiement[0].dateEcheance) {
        dateEcheance = facture.echeancierPaiement[0].dateEcheance;
      } else {
        const delaiReglement = facture.delaiReglement.estPersonnalisable
          ? facture.delaiReglementDetail
          : this.delaisReglementFacture.delaiReglementDetail;
        dateEcheance = calculDateEcheancier(facture.dateDevisCommande, delaiReglement);
      }

      facture.echeancierPaiement = (await echeancierGeneration({
        nombreEcheances: 1,
        datePremiereEcheance: dateEcheance,
        periodicite: devisConf.MOIS,
        montantTotal: facture.montantTtc - (facture.montantAcomptesAffectes || 0),
        modeReglementId: facture.modeReglementId,
      })).data.result;
    },
    async enregistrerDevisCommande() {
      if (this.isEditPrevisu) {
        this.popUpChoiceSavePrevisualisation = true;
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        await this.generationEcheancierPaiementSiUneLigneEchancierEtMontantDiff(
          this.nouveauDevisCommande,
        );
        if (this.isCommercial) this.nouveauDevisCommande.commercialId = this.utilisateur.id;
        const copieNouveauDevisCommande = preparationEnvoiBack(this.nouveauDevisCommande);
        copieNouveauDevisCommande.echeancierPaiement.forEach((element) => {
          element.dateEcheance = formatDate(element.dateEcheance);
        });
        copieNouveauDevisCommande.lignesCommande.forEach((ligne) => {
          ligne.dateReglement = formatDate(ligne.dateReglement);
          if (ligne.lignesCommande) {
            ligne.lignesCommande.forEach((ligneEnfant) => {
              ligneEnfant.dateReglement = formatDate(ligneEnfant.dateReglement);
            });
          }
        });
        let facture = {};
        if (this.isNewDevisCommande) {
          copieNouveauDevisCommande.societeId = this.societeActiveId;
          facture = (await create(copieNouveauDevisCommande)).data.result;
          await this.insertAttachments(facture.id);
          if (this.nouveauDevisCommande.sousType === devisConf.SOUS_TYPE_AVOIR
            || this.nouveauDevisCommande.sousType === devisConf.SOUS_TYPE_AVOIR_SUR_ACOMPTE
          ) {
            messageSucces(this.$i18n.t('editionFacture.messages.successCreationAvoir'));
          } else {
            messageSucces(this.$i18n.t('editionFacture.messages.successCreation'));
          }
        } else {
          facture = (await update(copieNouveauDevisCommande)).data.result;
          await this.updateAttachments(facture.id);
          if (this.nouveauDevisCommande.sousType === devisConf.SOUS_TYPE_AVOIR
            || this.nouveauDevisCommande.sousType === devisConf.SOUS_TYPE_AVOIR_SUR_ACOMPTE
          ) {
            messageSucces(this.$i18n.t('editionFacture.messages.editQuotationSuccessAvoir'));
          } else {
            messageSucces(this.$i18n.t('editionFacture.messages.editQuotationSuccess'));
          }
        }
        loadingComponent.close();
        await this.$router.push({ name: 'c.bodac.factures', params: { id: facture.id } });
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.findError(e.response);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    erreurRegroupementPersonnalise(messages) {
      this.messagesPopup = messages;
      this.isComponentPopUpErreurPerso = true;
    },
    findError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      validationDevisCommande(response,
        this.messages,
        this.isNewDevisCommande,
        this.isCreditNote ? devisConf.SOUS_TYPE_AVOIR : devisConf.TYPE_FACTURE);
      validationChampsObligatoireFacture(response, this.messages);
      validationGeneral(this.$i18n, response, this.champsVide,
        this.messages, this.messagesChampsVide, translate);
      this.error = true;
    },
    annuler() {
      this.$router.go(-1);
    },
    changeOnglet(name) {
      this.activeTab = name;
    },
    checkBeforeSave() {
      this.lignesSansProduitMessage = checkDcfBeforeSave(this.nouveauDevisCommande);
      if (this.lignesSansProduitMessage.length) {
        this.popUpProduit = true;
      } else this.enregistrerDevisCommande();
    },
    saveFacture() {
      this.openPopUpFactor = false;
      this.popUpProduit = false;
      this.enregistrerDevisCommande();
    },
    setUpFacture(sousType) {
      const nouveauDevisCommande = genererDevisCommande(
        devisConf.TYPE_FACTURE,
        sousType,
        this.societeActive,
        devisConf.SENS_VENTE,
        devisConf.MODULE_GESTION_COMMERCIALE,
      );
      nouveauDevisCommande.etat = devisConf.ETAT_BROUILLON;
      agenceInitialize(nouveauDevisCommande);
      if (this.utilisateur.profil === ASSISTANT_COMMERCIAL) {
        nouveauDevisCommande.assistantId = this.utilisateur.id;
      }
      if (this.utilisateur.profil === COMMERCIAL) {
        this.nouveauDevisCommande.commercialId = this.utilisateur.id;
        this.nouveauDevisCommande.commissions = [{
          commercialId: this.utilisateur.id,
          pourcentageRepartition: 100,
          selected: false,
        }];
      }
      return nouveauDevisCommande;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.setTypeDCFFace(devisConf.TYPE_FACTURE);
    this.setTypeDCFReseauLc(devisConf.TYPE_FACTURE);
    this.setTypeDCFReseauTempo(devisConf.TYPE_FACTURE);
    this.setTypeDCFReseauMairie(devisConf.TYPE_FACTURE);
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key,
      PARAMETRES_INTERNE_KEYS.moduleFactor.key,
      PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      PARAMETRES_INTERNE_KEYS.achatAASpe.key,
    ]);
    await this.loadParametres([PARAMETRES_KEYS.regimeTva, PARAMETRES_KEYS.delaiReglement]);
    await this.setAttachmentContext({ module: 'Facture' });
    if (this.commandeCourante) {
      let nouveauDevisCommande = this.commandeCourante;
      const messages = [];
      nouveauDevisCommande = await ajouterProduitDepuisPanierNumerique(
        this.panierNumerique, nouveauDevisCommande, this.regroupPersoNumerique,
        this.$i18n, messages, this.getRemiseTvaDefaut(nouveauDevisCommande),
      );
      if (this.useEcranAjoutReseauTempo) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierReseauTempo, nouveauDevisCommande, this.regroupPersoReseauTempo, this.$i18n,
          messages, produitConf.CATEGORIE_REGROUPEMENT,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefReseauTempo();
        this.clearPanierReseauTempo();
        this.setUseEcranAjoutReseauTempo(false);
      }
      if (this.useEcranAjoutFace) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierFace, nouveauDevisCommande, this.regroupPersoFace, this.$i18n, messages,
          produitConf.CATEGORIE_UNITAIRE, this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefFace();
        this.clearPanierFace();
        this.setUseEcranAjoutFace(false);
      }
      if (this.useEcranAjoutReseauMairie) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierReseauMairie, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_REGROUPEMENT_MAIRIE,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefReseauMairie();
        this.clearPanierReseauMairie();
        this.setUseEcranAjoutReseauMairie(false);
      }
      if (this.useEcranAjoutReseauLc) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierReseauLc, nouveauDevisCommande, this.regroupPersoReseauLc,
          this.$i18n, messages, produitConf.CATEGORIE_REGROUPEMENT_LC,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefReseauLc();
        this.clearPanierReseauLc();
        this.setUseEcranAjoutReseauLc(false);
      }
      if (this.useEcranAjoutSalon) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierSalon, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_SALON,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefSalon();
        this.clearPanierSalon();
        this.setUseEcranAjoutSalon(false);
      }
      if (this.useEcranAjoutSponsoring) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierSponsoring, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_SPONSORING,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefSponsoring();
        this.clearPanierSponsoring();
        this.setUseEcranAjoutSponsoring(false);
      }
      if (this.useEcranAjoutAutre) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierAutre, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_SPONSORING,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefAutre();
        this.clearPanierAutre();
        this.setUseEcranAjoutAutre(false);
      }
      if (this.useEcranAjoutPresse) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierPresse, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_PRESSE,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefPresse();
        this.clearPanierPresse();
        this.setUseEcranAjoutPresse(false);
      }
      nouveauDevisCommande.lignesCommande.forEach((ligne) => {
        ligne.selected = false;
      });
      await updateAffectionOfAllProduct(nouveauDevisCommande);
      this.masqueRemiseBase = nouveauDevisCommande.masqueRemise;
      this.getLignesMasqueLigne(nouveauDevisCommande.lignesCommande);
      this.clearBriefNumerique();
      this.clearPanierNumerique();
      this.removeCommande();
      if (this.$route.name === 'm.bodac.factures-client') {
        let intervenant = null;
        if (this.placeIntervenant === -1) {
          intervenant = nouveauDevisCommande.intervenants.find((int) => {
            return int.destinataire;
          });
        } else {
          intervenant = nouveauDevisCommande.intervenants.filter((int) => {
            return !int.destinataire;
          })[this.placeIntervenant];
        }
        await majIntervenant(intervenant, this.clientCourant);
        if (intervenant.commentairesFacturation) {
          if (!nouveauDevisCommande.commentaire) nouveauDevisCommande.commentaire = '';
          nouveauDevisCommande.commentaire = nouveauDevisCommande.commentaire.concat(intervenant.commentairesFacturation + '\n');
        }
        this.setClientCourant(null);
        this.setPlaceIntervant(0);
      }
      await updateModeCalculHonoraireLigneCommandeHonoraire(
        nouveauDevisCommande.lignesCommande,
        nouveauDevisCommande.intervenants,
      );
      regleFacturationInitialize(nouveauDevisCommande);
      this.nouveauDevisCommande = nouveauDevisCommande;
      if ((this.regroupPersoNumerique && this.panierNumerique)
        || (this.regroupPersoFace && this.panierFace.length > 0)
        || (this.regroupPersoReseauLc && this.panierReseauLc.length > 0)
        || (this.regroupPersoReseauTempo && this.panierReseauTempo.length > 0)) {
        this.changeOrder();
        if (messages.length > 0) {
          this.messagesPopup = messages;
          this.isComponentPopUpErreurPerso = true;
        }
      }
      this.findNewTypeProduit();
    } else {
      this.id = this.$route.params.id;
      if (this.id || this.$route.name === 'm.bodac.factures-avoir') {
        try {
          let nouveauDevisCommande = null;
          if (this.$route.name === 'm.bodac.factures-avoir') {
            if (this.avoirACreer !== null) {
              nouveauDevisCommande = cloneDeep(this.avoirACreer);
              this.setAvoirACreer(null);
              nouveauDevisCommande.dateDevisCommande = new Date(
                nouveauDevisCommande.dateDevisCommande,
              );
            } else {
              nouveauDevisCommande = this.setUpFacture(devisConf.SOUS_TYPE_AVOIR);
            }
          } else {
            nouveauDevisCommande = { ...(await factureGetter(this.id)) };
            if (nouveauDevisCommande.interne === true) {
              const routeName = nouveauDevisCommande.sens === devisConf.SENS_VENTE ? 'c.bodac.factures-venteInterne' : 'c.bodac.factures-achatVenteInterne';
              await this.$router.push({ name: routeName, params: { id: nouveauDevisCommande.id } });
              loadingComponent.close();
              return;
            }
          }
          nouveauDevisCommande.echeancierPaiement.sort();
          nouveauDevisCommande.echeancierPaiement.forEach((element) => {
            element.dateEcheance = gestionDateBase(element.dateEcheance);
          });
          nouveauDevisCommande.lignesCommande.forEach((ligne) => {
            ligne.selected = false;
          });
          await updateAffectionOfAllProduct(nouveauDevisCommande);
          this.nouveauDevisCommande = nouveauDevisCommande;
          this.masqueRemiseBase = this.nouveauDevisCommande.masqueRemise;
          this.getLignesMasqueLigne(this.nouveauDevisCommande.lignesCommande);
        } catch (e) {
          messageErreur(this.$i18n);
          loadingComponent.close();
          throw e;
        }
      } else if (this.factureCourante) {
        this.nouveauDevisCommande = this.factureCourante;
        this.removeFacture();
      } else {
        this.nouveauDevisCommande = this.setUpFacture(devisConf.SOUS_TYPE_NORMAL);
      }
    }
    if (this.nouveauDevisCommande.intervenants.length === 0) {
      const intervenant = genererIntervenant();
      intervenant.destinataire = true;
      defineTitreIntervenant(intervenant, this.$i18n);
      this.nouveauDevisCommande.intervenants.push(intervenant);
    }
    initializeCommandeDevis(this.nouveauDevisCommande, true);
    if (this.nouveauDevisCommande.id) {
      await this.setAttachmentElementId({ id: this.nouveauDevisCommande.id });
    }

    this.nouveauDevisCommande.intervenants.forEach((intervenant) => {
      if (intervenant.titre === null) {
        defineTitreIntervenant(intervenant, this.$i18n);
      }
    });

    const etat = devisConf.DEVIS_COMMANDE_ETAT.find((el) => {
      return el.code === this.nouveauDevisCommande.etat;
    });
    if (etat) {
      this.etatLibelle = etat.libelle;
    }
    this.factureSave = cloneDeep(this.nouveauDevisCommande);
    this.olTiersFactorId = this.nouveauDevisCommande.tiersFactorId;
    this.nouveauDevisCommande.factorDateTransmission = gestionDateBase(
      this.nouveauDevisCommande.factorDateTransmission,
    );
    loadingComponent.close();
    if (this.isNewDevisCommande) {
      this.setInformationPage(this.$t('pageGescom.facture.creation', { item: this.nouveauDevisCommande.code }));
    } else {
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.nouveauDevisCommande.code }));
    }
  },
};
</script>

<style scoped>

</style>
